module.exports = __webpack_public_path__ + "img/tivoli-sintra.d9728afc.jpg";